/** P2 체크리스트 요약 카드. */
import { ChecklistStatus, ChecklistSummary } from '../../services/checklistApi';

const LABELS: Record<ChecklistStatus, string> = {
  pass: '통과',
  ready: '준비됨',
  warn: '경고',
  fail: '실패',
  unknown: '검증 중',
  manual: '수동 확인',
  skip: '휴장 SKIP',
};

const ORDER: ChecklistStatus[] = ['pass', 'ready', 'warn', 'fail', 'unknown', 'manual', 'skip'];

export default function ChecklistSummaryBar({ summary }: { summary: ChecklistSummary }) {
  return (
    <section className="ck-summary">
      <div className={`ck-summary-headline ${summary.blocking ? 'blocking' : 'clear'}`}>
        <span className="ck-summary-label">LIVE 전환 준비도</span>
        <strong>
          {summary.blocking ? 'No-Go (blocking 항목 있음)' : 'Go 후보'}
        </strong>
        <span className="ck-summary-meta">
          총 {summary.total}건
        </span>
      </div>
      <div className="ck-summary-counts">
        {ORDER.map((status) => (
          <div key={status} className={`ck-summary-chip ck-chip-${status}`}>
            <span>{LABELS[status]}</span>
            <strong>{summary.counts[status] ?? 0}</strong>
          </div>
        ))}
      </div>
    </section>
  );
}
